import React from "react"
import StarRatings from 'react-star-ratings';
import ScreenReaderText from "@components/screen-reader-text"
import { Link } from "gatsby"

const ReviewsTeaser = ({ rating, reviewCount, starsFillColor, showReviewsText = true }) => {
  return (
    <div>
      <ScreenReaderText srText={`${rating} stars out of 5, with ${reviewCount} reviews`} />
      {rating > 0.0 ?
        <div className={`flex items-center gap-x-2 mt-2 ${!showReviewsText ? "ml-5" : ""}`}>
          <StarRatings
            starDimension="18px"
            className="flex items-center"
            rating={rating}
            starEmptyColor="#e5e6e6"
            starSpacing="1px"
            numberOfStars={5}
            starRatedColor={starsFillColor}
            svgIconViewBox="0 0 14 14"
            svgIconPath="M6.43972 1.22437C6.61607 0.681614 7.38393 0.681616 7.56028 1.22438L8.66385 4.62079C8.74271 4.86352 8.96891 5.02786 9.22413 5.02786H12.7953C13.366 5.02786 13.6033 5.75814 13.1416 6.09359L10.2524 8.19269C10.046 8.3427 9.95957 8.60861 10.0384 8.85134L11.142 12.2478C11.3184 12.7905 10.6971 13.2419 10.2354 12.9064L7.34627 10.8073C7.1398 10.6573 6.8602 10.6573 6.65373 10.8073L3.76456 12.9064C3.30286 13.2419 2.68165 12.7905 2.858 12.2478L3.96157 8.85134C4.04043 8.60861 3.95403 8.3427 3.74756 8.19269L0.858388 6.09359C0.396689 5.75814 0.633972 5.02786 1.20466 5.02786H4.77587C5.03109 5.02786 5.25729 4.86352 5.33615 4.62079L6.43972 1.22437Z"
            key={`stars_${3}`}
          />
          {showReviewsText &&
            <p className="inline-block mt-auto leading-1">
              {rating} Stars<Link to="#stamped-main-widget" className="leadig-1" tabIndex={-1}>, {reviewCount} Reviews</Link>
            </p>
          }
        </div>
        : <div className="mt-3">
          <p className="w-fit py-1 px-5 border rounded-xl bg-[#44A043] text-[#FFF] font-medium">
            New
          </p>
        </div>
      }
    </div>
  )
}

export default ReviewsTeaser
